import React from "react";
import { Search, X } from "lucide-react";

const GENDERS = [
  { key: "", label: "ALL" },
  { key: "M", label: "MALE" },
  { key: "F", label: "FEMALE" },
];

export const matchesLeaderboardFilters = (row, query, gender) => {
  const q = query.trim().toLowerCase();
  if (q && !(row.name || "").toLowerCase().includes(q)) return false;
  if (gender && (row.gender || "").charAt(0).toUpperCase() !== gender) return false;
  return true;
};

export const LeaderboardSearchBar = ({ query, onQuery, gender, onGender, prefix = "lb" }) => (
  <div className="flex flex-wrap items-center gap-3" data-testid={`${prefix}-search-bar`}>
    <div className="relative flex-1 min-w-[220px]">
      <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-mute pointer-events-none" />
      <input
        className="gps-input !pl-9 !pr-9"
        placeholder="Search athlete name..."
        value={query}
        onChange={(e) => onQuery(e.target.value)}
        data-testid={`${prefix}-search-input`}
      />
      {query && (
        <button
          onClick={() => onQuery("")}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-mute hover:text-white transition-colors"
          aria-label="Clear search"
          data-testid={`${prefix}-search-clear`}
        >
          <X size={14} />
        </button>
      )}
    </div>
    <div className="inline-flex gap-1 p-1 rounded-full border border-white/15 bg-white/[0.03]" data-testid={`${prefix}-gender-toggle`}>
      {GENDERS.map((g) => (
        <button
          key={g.label}
          onClick={() => onGender(g.key)}
          aria-pressed={gender === g.key}
          className={`px-4 py-1.5 rounded-full gps-mono text-[10px] tracking-[0.2em] transition-colors ${
            gender === g.key ? "bg-white text-black" : "text-mute hover:text-white"
          }`}
          data-testid={`${prefix}-gender-${g.label.toLowerCase()}`}
        >
          {g.label}
        </button>
      ))}
    </div>
  </div>
);
